<ion-button
  fill="outline"
  color="primary"
  expand="block"
  [disabled]="isOffline()"
  libClickStopPropagation
  (click)="showIncidenceModal()"
>
  <ion-icon
    slot="start"
    aria-hidden="true"
    src="../assets/material-symbols/warning_24dp.svg"
  ></ion-icon>
  {{ 'freight.general.incident' | translate }}
</ion-button>
